(() => {
  const ACTIVE_COLOR_CLASS = 'gift-color__value--active';
  const UNAVAILABLE_SIZE_CLASS = 'gift-size--unavailable';

  function parseVariants(block) {
    const source = block.querySelector('[data-gift-variants]');
    if (!source) return [];
    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      console.error('[gift-modal] invalid variant payload', error);
      return [];
    }
  }

  function initGiftBlock(block) {
    const variants = parseVariants(block);
    if (!variants.length) return;

    const image = block.querySelector('[data-gift-image]');
    const variantSelect = block.querySelector('select[name="id"]');
    const colorValues = Array.from(block.querySelectorAll('[data-gift-color]'));
    const sizeValues = Array.from(block.querySelectorAll('[data-size]'));
    const fallbackImageSrc = image ? image.getAttribute('src') : null;

    let selectedColor = colorValues.find(value => value.classList.contains(ACTIVE_COLOR_CLASS))?.dataset.giftColor || null;
    let selectedSize = null;

    const matchesSelection = (variant, size) =>
      (!selectedColor || variant.color === selectedColor) && (!size || variant.size === size);

    const findVariant = size => variants.find(variant => matchesSelection(variant, size)) || null;

    function syncSizeTargets() {
      sizeValues.forEach(sizeValue => {
        const variant = findVariant(sizeValue.dataset.size);
        sizeValue.dataset.target = variant ? variant.id : '';
        sizeValue.classList.toggle(UNAVAILABLE_SIZE_CLASS, !variant);
      });
    }

    function syncImage() {
      if (!image) return;
      const variantWithImage = variants.find(variant => matchesSelection(variant, null) && variant.image);
      image.src = variantWithImage ? variantWithImage.image : fallbackImageSrc;
    }

    function syncSelectedVariant() {
      let variant = findVariant(selectedSize);
      if (!variant) {
        selectedSize = null;
        sizeValues.forEach(sizeValue => sizeValue.classList.remove('active'));
        variant = findVariant(null);
      }
      if (variant && variantSelect) variantSelect.value = variant.id;
    }

    function selectColor(color) {
      selectedColor = color;
      colorValues.forEach(colorValue =>
        colorValue.classList.toggle(ACTIVE_COLOR_CLASS, colorValue.dataset.giftColor === color)
      );
      syncSizeTargets();
      syncImage();
      syncSelectedVariant();
    }

    colorValues.forEach(colorValue => {
      colorValue.addEventListener('click', () => selectColor(colorValue.dataset.giftColor));
      colorValue.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        selectColor(colorValue.dataset.giftColor);
      });
    });

    sizeValues.forEach(sizeValue => {
      sizeValue.addEventListener('click', () => {
        if (sizeValue.classList.contains(UNAVAILABLE_SIZE_CLASS)) return;
        selectedSize = sizeValue.dataset.size;
        syncSelectedVariant();
      });
    });

    syncSizeTargets();
    syncSelectedVariant();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.gamification-modal [data-gift-block]').forEach(initGiftBlock);
  });
})();
